"use client"

import { useState } from "react"
import { motion } from "framer-motion"
import LyricsResult from "../components/LyricsResult"
import LyricsForm from "../components/LyricsForm"
import { Music } from 'lucide-react'

function MusicLyrics() {
  const [lyrics, setLyrics] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [songInfo, setSongInfo] = useState(null)

  const handleSubmit = async (singer, songTitle) => {
    setLoading(true)
    setError(null)
    setLyrics(null)
    setSongInfo(null)

    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("x-apihub-key", "dC-X6X1n75W9ul7oEz2tOmvuaww1WLB3cGiKWsfsq057qO4-Ay")
    myHeaders.append("x-apihub-host", "Lyrics-Search-API.allthingsdev.co")
    myHeaders.append("x-apihub-endpoint", "69b349e2-302b-4a16-bbca-10d44727f12c")

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    }

    try {
      const response = await fetch(
        `https://Lyrics-Search-API.proxy-production.allthingsdev.co/v1/${encodeURIComponent(singer)}/${encodeURIComponent(songTitle)}`,
        requestOptions,
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      console.log("API Response:", result)

      if (result.lyrics) {
        setLyrics(result.lyrics)
        setSongInfo({ singer, songTitle })
      } else {
        throw new Error("No lyrics found in the response")
      }
    } catch (error) {
      console.error("Error:", error)
      setError("An error occurred while fetching the lyrics. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-4xl mx-auto px-4">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-8"
      >
        <Music className="inline-block text-indigo-600 mb-4" size={48} />
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white">Song Lyrics Finder</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mt-2">
          Find lyrics for your favorite songs instantly!
        </p>
      </motion.div>
      <LyricsForm onSubmit={handleSubmit} isLoading={loading} />
      {error && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-red-500 text-center mt-4"
        >
          {error}
        </motion.p>
      )}
      {lyrics && <LyricsResult lyrics={lyrics} songInfo={songInfo} />}
    </div>
  )
}

export default MusicLyrics
